import { useMemo } from "react";

import { resolveCompositionColumnTarget } from "@/routes/smart-table/utils/compositionColumns";
import type { SheetDataStore } from "@/routes/smart-table/stores/sheet-data-store";

interface UseDialogColumnTargetParams {
  columnId: string;
  dialogParentColumnId?: string;
  dialogCompositionSource?: string;
  columns: SheetDataStore["columns"] | undefined;
}

export function useDialogColumnTarget({
  columnId,
  dialogParentColumnId,
  dialogCompositionSource,
  columns,
}: UseDialogColumnTargetParams) {
  return useMemo(() => {
    if (dialogParentColumnId) {
      return {
        storageColumnId: dialogParentColumnId,
        displayColumnId: columnId,
        compositionSource: dialogCompositionSource,
      };
    }

    const resolvedTarget = resolveCompositionColumnTarget(columnId, columns);

    return {
      storageColumnId: resolvedTarget.storageColumnId,
      displayColumnId: resolvedTarget.displayColumnId,
      compositionSource: resolvedTarget.source?.source,
    };
  }, [columnId, dialogCompositionSource, dialogParentColumnId, columns]);
}
